<template>
  <v-row
    no-gutters>
    <v-col
      cols="1"
      class="px-2">
      <img
        :src="imageUrl ? $convertImgix(`${imageUrl}?w=1024`) : noPicture"
        style="width: 60px; height: 80px;"
        class="rounded my-1 elevation-1" />
    </v-col>
    <v-col
      cols="3"
      class="px-2">
      <h4 class="subtitle-1 font-weight-bold">
        {{ sketchId }}
      </h4>
      <p class="mb-0 text-body">
        {{ color }}
      </p>
    </v-col>
    <v-col
      v-if="!hideCompositions"
      cols="5"
      class="px-2">
      <div class="mb-0">
        <p class="subtitle-1 mb-0">
          <span class="font-weight-bold">Fabric Compositions :</span>
          <span
            v-if="!fabrics.length"
            class="red--text ml-2">ไม่ระบุ</span>
        </p>
        <div v-if="fabrics.length">
          <div
            v-for="(fabric, index) in fabrics"
            :key="`fb-${index}`"
            class="pl-2"
          >
            <p
              v-if="fabric.garmentPart"
              class="text-caption mb-0 font-weight-bold">
              {{ fabric.garmentPart.en }}
            </p>
            <p
              v-if="fabric.compositions"
              class="text-caption mb-0">
              - {{ joinCompositions(fabric.compositions) }}
            </p>
          </div>
        </div>
      </div>
    </v-col>
    <v-col
      :offset="hideCompositions ? 5 : 0"
      cols="3"
      class="px-2">
      <v-row
        no-gutters
        class="d-flex flex-column"
        style="height: 100%;">
        <v-col
          v-if="fabrics.length && !incomplete && !hideInput"
          class="d-flex justify-end">
          <v-btn
            small
            :disabled="!fabrics.length"
            color="secondary"
            @click="showExample">
            ตัวอย่าง
          </v-btn>
        </v-col>

        <v-spacer></v-spacer>

        <v-col class="d-flex justify-end align-center">
          <v-btn
            icon
            class="mr-3"
            dark
            small
            @click="removeItem()">
            <v-icon color="red">
              mdi-delete
            </v-icon>
          </v-btn>
          <v-text-field
            v-if="fabrics.length && !incomplete && !hideInput"
            v-model.number="innerAmount"
            class="number-field"
            color="secondary"
            outlined
            dense
            min="1"
            hide-details
            prepend-inner-icon="mdi-minus"
            append-icon="mdi-plus"
            @click:prepend-inner="removeAmount()"
            @click:append="addAmount()" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import NoPicture from '@/assets/image/no_picture_available.png'

export default {
  props: {
    sketchId: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => []
    },
    price: {
      type: Number,
      default: 0
    },
    qty: {
      type: Number,
      default: 1
    },
    fabrics: {
      type: Array,
      default: () => []
    },
    incomplete: {
      type: Boolean,
      default: false
    },
    hideInput: {
      type: Boolean,
      default: false
    },
    hideCompositions: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      noPicture: NoPicture,
      dialogFabric: false
    }
  },
  computed: {
    innerAmount: {
      get () {
        return this.qty
      },
      set (val) {
        this.$emit('update:qty', val || 1)
      }
    }
  },
  methods: {
    addAmount () {
      this.innerAmount += 1
    },
    removeAmount () {
      if (this.innerAmount === 1) {
        return
      }

      this.innerAmount -= 1
    },
    removeItem () {
      this.$emit('remove-item')
    },
    joinCompositions (compositions) {
      return compositions.map((item) => `${item.percentage}% ${item.name}`).join(', ')
    },
    showExample () {
      this.$emit('showExample', { fabrics: this.fabrics, sketchId: this.sketchId, color: this.color })
    }
  }
}
</script>

<style scoped>

</style>
